const STOCK_CACHE_KEY = "stockCache";
//const STOCK_TTL_MS = 5 * 60 * 1000; // 5 minutos
const STOCK_TTL_MS = 1; // 15 minutos

function getStockCache() {
  try {
    return JSON.parse(localStorage.getItem(STOCK_CACHE_KEY)) || {};
  } catch (e) {
    return {};
  }
}

function setStockCache(cache) {
  localStorage.setItem(STOCK_CACHE_KEY, JSON.stringify(cache));
}

function isCacheValid(entry) {
  return (
    entry && entry.timestamp && Date.now() - entry.timestamp < STOCK_TTL_MS
  );
}

function cleanExpiredStockCache() {
  const cache = getStockCache();
  const now = Date.now();
  const newCache = {};
  for (const sku in cache) {
    if (isCacheValid(cache[sku])) {
      newCache[sku] = cache[sku];
    }
  }
  setStockCache(newCache);
}

// Limpiar al cargar
cleanExpiredStockCache();

const checkStock = async (sku, forceFresh = false) => {
  // console.log("checkStock", sku, forceFresh);
  const cache = getStockCache();
  const cachedEntry = cache[sku];

  if (!forceFresh && isCacheValid(cachedEntry)) {
    return cachedEntry.data;
  }

  try {
    const response = await fetch(
      "https://toyplanet.lineagrafica.es/api/canarias/stock/check",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ sku }),
      }
    );

    const data = await response.json();

    cache[sku] = {
      timestamp: Date.now(),
      data: data.data,
    };
    setStockCache(cache);

    return data.data;
  } catch (err) {
    console.warn("Error al comprobar stock, se ignora:", err);
    return null; // ← si hay error, no bloquea nada
  }
};

const checkStockAvailability = async () => {
  const skuSpan = document.querySelector(".product-sku");
  if (!skuSpan) return;

  let sku = skuSpan.textContent.split(" ")[1];
  if (!sku) return;

  const data = await checkStock(sku);
  if (!data) return; // ignorar error

  let stock = window.isCanarias
    ? data.quantity
    : data.shopLocation?.quantity || 0;
  let hasStock = window.isCanarias
    ? data.hasStock
    : data.shopLocation?.hasStock || false;

  if (!hasStock) {
    const badge = document.querySelector(".badge.out-of-stock");
    if (badge) badge.style.display = "inline-flex";

    const adToCartButton = document.querySelector("#AddToCart");
    if (adToCartButton) {
      adToCartButton.disabled = true;
      adToCartButton.classList.add("disabled");

      const addToCartButtonText = adToCartButton.querySelector(
        ".single-add-to-cart-button--text"
      );
      if (addToCartButtonText) {
        addToCartButtonText.textContent =
          addToCartButtonText.textContent === "Añadir al carrito"
            ? "Agotado"
            : "Out of stock";
      }
    }

    const quantityInput = document.querySelector(".quantity input");
    const quantityMax = document.querySelector(".quantity .plus");
    const quantityMinus = document.querySelector(".quantity .minus");

    if (quantityInput) {
      quantityInput.max = stock;
      quantityInput.disabled = true;
    }
    if (quantityMax) quantityMax.disabled = true;
    if (quantityMinus) quantityMinus.disabled = true;
  }

  const quantityInput = document.querySelector(".product-form .quantity input");
  if (quantityInput) quantityInput.max = stock;
};

document.addEventListener("DOMContentLoaded", () => {
  const cartDrawer = document.querySelector("cart-drawer");
  const themeCart = document.querySelector(".thb-cart-form--cart-notes-true");
  let collapsibleShipping = null;
  let collapsibleRecommendations = null;

  const beforeCartUpdate = () => {
    collapsibleShipping = document
      .querySelector(".shipping-estimator--container")
      ?.cloneNode(true);
    collapsibleRecommendations = document
      .querySelector(".cart-recommendations--full")
      ?.cloneNode(true);
  };

  const afterCartUpdate = async () => {
    const items = await getCartItems();

    if (items.length > 0) {
      const cartContainer = document.querySelector(
        ".thb-cart-form--cart-notes-true div"
      );

      if (
        collapsibleShipping &&
        !document.querySelector(".shipping-estimator--container")
      ) {
        cartContainer.appendChild(collapsibleShipping);
      }

      if (
        collapsibleRecommendations &&
        !document.querySelector(".cart-recommendations--full")
      ) {
        cartContainer.appendChild(collapsibleRecommendations);
      }
    }
  };

  const getCartItems = () => {
    return fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) =>
        cart.items.map((item) => ({
          key: item.key,
          id: item.id,
          sku: item.sku,
          quantity: item.quantity,
        }))
      );
  };

  const updateCartStockInfo = async () => {
    if (!collapsibleShipping && !collapsibleRecommendations) {
      setTimeout(beforeCartUpdate, 1000);
    }

    const items = await getCartItems();
    let needsRefresh = false;

    for (const item of items) {
      const data = await checkStock(item.sku);
      if (!data) continue;

      const quantityInputs = document.querySelectorAll(
        `quantity-selector[data-id*="${item.key}"] input.qty`
      );
      const quantityPluses = document.querySelectorAll(
        `quantity-selector[data-id*="${item.key}"] .plus`
      );

      let stock = 0;
      if (window.isCanarias) {
        stock = data.quantity;
      } else {
        stock = data.shopLocation?.quantity || 0;
      }

      quantityInputs.forEach((input) => {
        input.max = stock;
        input.disabled = true;
      });

      quantityPluses.forEach((plus) => {
        if (item.quantity == stock) {
          plus.classList.add("disabled");
        }
      });

      if (item.quantity > stock) {
        if (stock <= 0) {
          await updateCart(item.key, 0);
          needsRefresh = true;
        } else {
          await updateCart(item.key, stock);
          needsRefresh = true;
        }
      }
    }

    if (needsRefresh) {
      document.dispatchEvent(new Event("cart:refresh"));
    }
  };

  const updateCart = async (id, quantity) => {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, quantity }),
    });
  };

  let isValidatingCheckout = false;

  const validateCartBeforeCheckout = async (cartForm) => {
    if (isValidatingCheckout) return false; // bloquea reentradas
    isValidatingCheckout = true;

    const items = await getCartItems();
    let hasErrors = false;

    for (const item of items) {
      const data = await checkStock(item.sku, true);
      if (!data) continue;

      let stock = window.isCanarias
        ? data.quantity
        : data.shopLocation?.quantity || 0;
      if (item.quantity > stock) {
        hasErrors = true;
        await updateCart(item.key, Math.max(0, stock));
      }
    }

    if (hasErrors) {
      document.dispatchEvent(new Event("cart:refresh"));
      await refreshCartHeader();
      alert(
        "Hemos actualizado tu carrito porque había artículos sin stock suficiente."
      );
    }

    isValidatingCheckout = false;
    return !hasErrors;
  };

  async function refreshCartHeader() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      // Actualizar contador de items
      const countEl = document.querySelector(".thb-secondary-area--item-count");
      if (countEl) {
        countEl.textContent = cart.item_count;
      }

      // Actualizar importe total
      const amountEl = document.querySelector(
        ".thb-secondary-area--item-amount"
      );
      // console.log("amountEl", amountEl, cart.total_price);
      if (amountEl) {
        amountEl.textContent = formatMoney(cart.total_price);
      }
    } catch (err) {
      console.warn("Error refrescando header cart:", err);
    }
  }

  function formatMoney(cents) {
    if (!cents && cents !== 0) return "";
    const euros = (Number(cents) / 100).toFixed(2); // "2100.00"
    const parts = euros.split("."); // ["2100", "00"]
    // Insertar punto de miles
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return "€" + parts.join(",");
  }

  function attachCheckoutListener() {
    const checkoutButton = document.querySelector(
      'button[name="checkout"][form="cart-form"]'
    );
    const cartForm = document.getElementById("cart-form");

    if (!checkoutButton || !cartForm) return;

    const handler = async (e) => {
      e.preventDefault();
      const valid = await validateCartBeforeCheckout(cartForm);
      if (valid) {
        // 🔑 en lugar de .submit() → redirigimos directamente
        window.location.href = "/checkout";
      }
    };

    checkoutButton.addEventListener("click", handler);
  }
  
  if (cartDrawer) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "inert"
        ) {
          const isOpen = !cartDrawer.hasAttribute("inert");
          if (isOpen) {
            updateCartStockInfo();
          }
        }
      }
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["inert"],
    });

    const cartDrawerObserver = new MutationObserver(() => {
      updateCartStockInfo();
    });

    cartDrawerObserver.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }

  if (themeCart) {
    const cartObserver = new MutationObserver(() => {
      updateCartStockInfo();
      afterCartUpdate();
      attachCheckoutListener();
    });

    cartObserver.observe(themeCart, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener("cart:refresh", () => {
    updateCartStockInfo();
  });

  attachCheckoutListener();
});

// console.log(window.isCanarias);
checkStockAvailability();
document.dispatchEvent(new Event("cart:refresh"));